import { Injectable } from '@angular/core';
import { TranslateService } from 'ng2-translate/ng2-translate';

@Injectable()
export class DesksService {
    constructor(private translate: TranslateService) { this.translateDescs(); }

    translateDescs() {
        var ofs =0;
        this.translate.get('DESCS_MENU.GRAPHIC').subscribe((res: string) => { this.desks[ofs++].label = res; });
        this.translate.get('DESCS_MENU.ALGEBRA').subscribe((res: string) => { this.desks[ofs++].label = res; });
      //  this.translate.get('DESCS_MENU.GEOMETRY').subscribe((res: string) => { this.desks[ofs++].label = res; });
        this.translate.get('DESCS_MENU.MEDIA').subscribe((res: string) => { this.desks[ofs++].label = res; });
        this.translate.get('DESCS_MENU.LINK_YOUTUBE').subscribe((res: string) => { this.desks[ofs++].label = res; });
      //  this.translate.get('DESCS_MENU.FABRIC').subscribe((res: string) => { this.desks[5].label = res; });
        this.translate.get('DESCS_MENU.TEXT').subscribe((res: string) => { this.desks[ofs++].label = res; });
        
       // this.translate.get('DESCS_MENU.CODE').subscribe((res: string) => { this.desks[7].label = res; });

    }
    getDesks() {
        return this.desks;
    }
    desks = [
        { value: "FABRIC", label: "Графична" },
        { value: "ALGEBRA", label: "Алгебра" },
       // { value: "GEOMETRY", label: "Геометрия" },
        { value: "MEDIA", label: "Медия" },
        { value: "LINK_YOUTUBE", label: "Линк" },
      //  { value: "GRAPHIC", label: "Графична 2" },
     //   { value: "CODE", label: "Код" },
        { value: "TEXT", label: "Текст" },
      //   { value: "CHAT", label: "Chat" },
    //  { value: "GEOGEBRA", label: "Geogebra" }

    ];
    getDescValue(key) {
        for (let d of this.desks) {
            if (d.value == key) return d.label
        }
    }
}


// WEBPACK FOOTER //
// /app/src/app/wb/desksmenu/desks.service.ts